if (!customElements.get("cart-drawer-subtotal")) {
    
     interface DefaultDiscountCode {
        timestamp: string
        customRules: any[]
        discount: Discount
        valid: boolean
        warnings: any[]
      }
    interface DiscountCodesStoraged {
      discounts_cupons: {
        discount_codes: Record<string, Points | Cashback>
      }
      code: string
      message_color: any[]
      data: { discount: Discount }
      discount_config: any
      disable_default_message: boolean
      discount_default: DefaultDiscountCode
      discount_default_alternative?: DefaultDiscountCode
    }

    interface Points {
      type: string
      multiplier: number
      multiplier_club: number
      text_grup_1: string
      text_grup_2: string
    }

    interface Cashback {
      type: string
      multiplier: number
    }

    interface Discount {
      allocation_method: string
      target_selection: string
      target_type: string
      value: string
      value_type: string
      allocation_limit: any
      entitled_product_ids: any[]
      entitled_variant_ids: any[]
      entitled_collection_ids: number[]
      usage_count: number
      usage_limit: any
      changed_value: boolean
      code: string
    }
  customElements.define(
    "cart-drawer-subtotal",
    class CartDrawerSubtotal extends HTMLElement {

      discountCodesStoraged: DiscountCodesStoraged | null = null;
      value: number
      totalPriceFromCart: number
      pixAsOriginalPrice: boolean
      hasPixDiscountInCart: boolean
      pixDiscountValue: number

      static get observedAttributes() {
        return ["data-value"];
      }

      constructor() {
        super();
        this.value = this.dataset.value ? parseInt(this.dataset.value) : 0;
        this.pixAsOriginalPrice = this.dataset.pixAsOriginalPrice === 'true' ? true : false;
        this.pixDiscountValue = this.dataset.pixDiscountValue ? parseFloat(this.dataset.pixDiscountValue) : 0;
        this.hasPixDiscountInCart = this.dataset.hasPixDiscountInCart === 'true' ? true : false;
        this.totalPriceFromCart = this.dataset.totalPrice ? parseInt(this.dataset.totalPrice) : 0;
      }

      attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name !== "data-value") return;
        const next = newValue ? parseInt(newValue) : 0;
        this.value = Number.isNaN(next) ? 0 : next;
        this.init();
      }

      connectedCallback(): void {
        setTimeout(() => {
          this.init();
        }, 2000);
      }

      getDiscountCodeStoraged() {
        const handlePromotionCouponReady = () => {
          const data = sessionStorage.getItem('insider:cart:promotionCoupon');
          if (data) this.discountCodesStoraged = JSON.parse(data) as DiscountCodesStoraged;
        }
        handlePromotionCouponReady();
        window.addEventListener('PromotionCouponReady', () => {
          this.dataset.timestamp = `priceNormalize:getDiscountCodeStoraged:PromotionCouponReady-${new Date().toISOString()}`;
          handlePromotionCouponReady();
          this.init();
        });
      }

      getAppliedDiscount() {
        // Clona a mensagem completa para preservar o layout especial de experimento (+OFF, cupom e estilos).
        const container = document.querySelector('#CartDrawer .cart-items .coupon-code-message') as HTMLElement | null;
        if(!container) return null;
        return container.cloneNode(true) as HTMLElement;
      }

      createOldPrice() {
        const container = document.createElement('span');
        container.className = 'subtotal__header--value'
        container.textContent = `R$ ${(this.value * 0.01).toFixed(0)}`
        return container;
      }

      createCouponAdvice() {
        const container = document.createElement('div');
        container.className = 'coupon-advice'
        container.textContent = `*mediante aplicação do cupom no checkout`
        return container;
      }
      createNewPrice(price: number, withPix?: boolean) {
        const container = document.createElement('div');
        container.className = 'new-cart-subtotal'
        const priceText = document.createElement('span');
        priceText.style.fontWeight = '600';
        priceText.style.fontSize = '16px';
        priceText.textContent = `R$ ${(price).toFixed(0)}`
        container.prepend(priceText);
        if(withPix) {
          const auxiliarText = document.createElement('span');
          auxiliarText.textContent = ' no pix'
          container.append(auxiliarText);
        }
        return container;
      }

      init() {
        this.innerHTML = '';
        this.getDiscountCodeStoraged()
        this.prepend(this.createOldPrice());
        let totalPrice = 0;
        document.querySelectorAll('#CartDrawer .cart-items price-normalize .init-price').forEach((el, index) => {
          const value = Number(el.textContent ? el.textContent.replace(/\D/g, '') : '0');
          totalPrice += value;
        });

        const subtotalValueForDisplay = this.hasPixDiscountInCart
          ? Number((this.totalPriceFromCart * 0.01).toFixed(0))
          : totalPrice;

        this.dataset.priceWithDiscountCode = String(subtotalValueForDisplay);

        if (subtotalValueForDisplay === 0) return;
        if(totalPrice === Number((this.value * 0.01).toFixed(0))) return;
        // if(!this.pixAsOriginalPrice && !this.hasPixDiscountInCart) return;
        this.append(this.createNewPrice(subtotalValueForDisplay, this.pixAsOriginalPrice))
        const appliedDiscount = this.getAppliedDiscount();
        if(!appliedDiscount) return;
        this.append(appliedDiscount)
        this.append(this.createCouponAdvice());
      }
    })

  }